import i18n from '../i18n';

export const getPackageTranslation = (t, sub, fieldName = 'package_name') => {
    const packageName = sub[fieldName].split(' ');
    const isNumberAfter = !!(+packageName[1].replace('+', ''));
    return `${t(`settingsPage.packages.${packageName[0]}`)} ${isNumberAfter ? packageName[1] : t(`settingsPage.packages.${packageName[1].replace(/"/g, '')}`)}`;
};

export  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
};
